module.exports = __webpack_public_path__ + "img/no_filter_filled_24.75620202.svg";